import { ThreeDots } from "react-loader-spinner";

const AuthLoading = ({
  backgroundColor = "white",
  color = "black",
  height = 100,
  width = 100,
}: {
  color: string;
  backgroundColor: string;
  height?: string | number;
  width?: string | number;
}) => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        backgroundColor,
      }}
    >
      <ThreeDots color={color} height={height} width={width} />
    </div>
  );
};

export default AuthLoading;
